export enum CarouselVerticalAlignment {
  TOP = 'v-align-top',
  CENTER = 'v-align-center',
  BOTTOM = 'v-align-bottom'
}
